import {ModalState} from "../../../types/modals";
import {ChangeLog} from "../../../types/admin";
import {createAsyncThunk, createSlice, PayloadAction} from "@reduxjs/toolkit";
import {api} from "../../api";

export type EventModalState = ModalState & {
    event_id: string | null
    key: string
    message: string
    date: string
    name: string
    type: string
    changes: ChangeLog[]
}

const initialState: EventModalState = {
    loading: true,
    isOpen: false,
    error: null,
    event_id: null,
    key: '',
    message: '',
    date: '',
    name: '',
    type: '',
    changes: []
}

export const getEvent = createAsyncThunk(
    'eventModal/getEvent',
    async (event_id: string, thunkAPI) => {
        try {
            return await api.get(`/API/admin/events/${event_id}/`);
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const slice = createSlice({
    name: 'eventModal',
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
        openModal: (state, action: PayloadAction<{event_id: string}>) => {
            state.event_id = action.payload.event_id;
            state.isOpen = true;
        },
        closeModal: () => {
            return initialState;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getEvent.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getEvent.fulfilled, (state, action) => {
                state.loading = false;
                state.event_id = action.payload.event_id;
                state.key = action.payload.key;
                state.message = action.payload.message;
                state.date = action.payload.date;
                state.name = action.payload.name;
                state.type = action.payload.type;
                state.changes = action.payload.changes;
            })
            .addCase(getEvent.rejected, (state, action) => {
                state.loading = false;
                if (typeof action.payload === 'string') {
                    state.error = action.payload as string;
                } else if (typeof action.error?.message === 'string') {
                    state.error = action.error.message;
                }
            })
    }
});

export const {openModal, closeModal} = slice.actions;
export default slice.reducer;